import { Camera, MessagesSquare, FileCheck2, Hammer } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, SectionHead } from "@/components/apex/primitives";

const ICONS = [Camera, MessagesSquare, FileCheck2, Hammer];

const Process = () => {
  const { t } = useLang();
  return (
    <section data-testid="process-section" className="ap-dark relative py-14 sm:py-20">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <SectionHead align="center" dark label={t.process.label} title={t.process.title} />

        <ol className="relative mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          <span
            className="pointer-events-none absolute inset-x-[12%] top-8 hidden border-t-2 border-dashed border-white/15 lg:block"
            aria-hidden="true"
          />
          {t.process.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={s} delay={0.08 * i} as="li">
                <div className="group relative flex h-full flex-col items-center text-center">
                  <span className="ap-icon relative h-16 w-16 ring-8 ring-[var(--charcoal)]">
                    <Icon className="h-7 w-7" strokeWidth={1.6} />
                    <span className="ap-mono absolute -end-1 -top-1 grid h-6 w-6 place-items-center rounded-full bg-white text-[11px] font-bold text-[var(--charcoal)]">
                      {i + 1}
                    </span>
                  </span>
                  <p className="mt-6 max-w-[240px] text-[15px] font-medium leading-[1.8] text-white/85">{s}</p>
                </div>
              </Reveal>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default Process;
